<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-01-08 09:13:16
 * @Description: 甘特图右侧上方俩级时间轴
-->
<template>
  <div
    class="gantt-header"
    :class="{
      'gantt-outbox-border': (!$store.state.viewSchem.noGanttOutBoxBorder),
      'bold': (!$store.state.viewSchem.timeLineFontNomal)
    }"
    ref="timeLines"
    :style="{
      'font-size': timelineFontSize + 'px'
    }"
  >
    <!-- 第一级显示 -->
    <div
      v-if="timesFirstShow"
      class="gantt-row gantt-row-first"
    >
      <template v-for="(item, index) in timesFirst">
        <div
          :key="index"
          class="cell-item"
          :style="{
            'width': `${item.width}px`,
            'left': `${item.left}px`,
          }"
          :title="item.show"
        >
          <span>{{ item.show}}</span>

        </div>
      </template>
    </div>
    <!-- 第二级显示 -->
    <div
      class="gantt-row gantt-row-sec"
      :class="{
        'gantt-row-vertical': isVerticalMode
      }"
      @contextmenu.prevent.stop="ContextmenuHandle($event)"
    >
      <template v-for="(item2, index2) in timesSec">
        <div
          :key="index2 + $store.state.cellUnitType"
          class="cell-item"
          :class="{
            'cell-item-weekend': (item2.holidayType === 1 || item2.holidayType === 3),
            'cell-item-bg': item2.isBgDate,
          }"
          :style="{
            'width': $store.getters.cellWidth + 'px',
            'left': index2 * $store.getters.cellWidth + 'px',
          }"
          :title="item2.title"
        >
          <template v-if="isVerticalMode">
            <span>{{ item2.show.split("")[0]}}</span>
            <br />
            <span>{{item2.show.split("")[1]}}</span>
          </template>
          <template v-else>
            <span>{{ item2.show}}</span>
            <!-- 周·刻度竖条 -->
            <div class="week-box" v-if="isWeekLineShow">
              <div class="week-col"></div>
              <div class="week-col"></div>
              <div class="week-col"></div>
              <div class="week-col"></div>
              <div class="week-col"></div>
              <div class="week-col"></div>
              <div class="week-col"></div>
            </div>
          </template>

        </div>

      </template>

    </div>
    <!-- 第三级显示 -->
    <div
      v-if="timesThirdShow"
      class="gantt-row gantt-row-third"
      @contextmenu.prevent.stop="ContextmenuHandle($event)"
    >
      <template v-for="(item3, index3) in timesSec">
        <div
          :key="index3 + $store.state.cellUnitType"
          class="cell-item"
          :class="{
            'cell-item-weekend': (item3.holidayType === 1 || item3.holidayType === 3),
            'cell-item-bg': item3.isBgDate,
          }"
          :style="{
            'width': $store.getters.cellWidth + 'px',
            'left': index3 * $store.getters.cellWidth + 'px',
          }"
          :title="item3.thirdShow"
        >
          <span>{{ item3.thirdShow }}</span>

        </div>
      </template>
    </div>

    <!-- 第四级显示 -->
    <div
      v-if="timesFourthShow"
      class="gantt-row gantt-row-fourth"
      @contextmenu.prevent.stop="ContextmenuHandle($event)"
    >
      <template v-for="(item4, index4) in timesSec">
        <div
          :key="index4 + $store.state.cellUnitType"
          class="cell-item"
          :class="{
            'cell-item-weekend': (item4.holidayType === 1 || item4.holidayType === 3),
            'cell-item-bg': item4.isBgDate,
          }"
          :style="{
            'width': $store.getters.cellWidth + 'px',
            'left': index4 * $store.getters.cellWidth + 'px',
          }"
          :title="item4.fourthShow"
        >
          <span>{{ item4.fourthShow }}</span>

        </div>
      </template>
    </div>


  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  created() {},
  mounted() {

  },
  computed: {
    timelineFontSize() {
      const _timelineFontSize = (this.$store.state.viewSchem && this.$store.state.viewSchem.timelineFontSize > 0) ? this.$store.state.viewSchem.timelineFontSize : 12;
      return _timelineFontSize;
    },
    // 周单位内刻度线展示
    isWeekLineShow() {
      const type = this.$store.state.cellUnitType;
      const scale = this.$store.getters.realCellScale;
      if (
        type === "week" &&
        scale >= 0.6
      ) {
        return true;
      }
      return false;
    },
    // 竖直展示模式
    isVerticalMode() {
      const _isVerticalMode = this.$store.state.viewSchem.isVerticalMode;
      return _isVerticalMode;
    },
    // 换算一级时间轴单位
    timesFirstShow() {
      const _timesFirstShow = this.$store.getters.timelineShowRows ? (this.$store.getters.timelineShowRows > 1) : false;
      return _timesFirstShow;
    },
    timesFirst() {
      if (!this.timesFirstShow || this.$store.state.viewSchem.isIndexMode) {
        return [];
      }
      const arr = this.$store.getters.durationTimeArr;
      const result = [];
      const cellOneWidth = this.$store.getters.cellWidth;
      const _type = this.$store.state.cellUnitType;

      let _dw = "day";
      let _showFormat;
      if (_type == "hour") {
        _dw = "day";
        _showFormat = "YYYY-MM-DD";
      } else if (_type == "day") {
        _dw = "month";
        _showFormat = "YYYY-MM";
      } else if (
        _type == "month" || _type == "week"
      ) {
        _dw = "year";
        _showFormat = "YYYY";
      }
      let count = 1;
      let leftIndex = 0;
      if (arr.length > 1) {
        for (let i = 0; i < arr.length - 1; i++) {

          const flag = arr[i].date.isSame(arr[i + 1].date, _dw);
          if (!flag || i == arr.length - 2) {
            if (i == arr.length - 2) {
              count++;
            }
            const _width = count * cellOneWidth;
            result.push({
              left: leftIndex,
              width: _width,
              show: arr[i].date.format(_showFormat),
              date: arr[i].date,
            });
            leftIndex += _width;
            count = 1;
          } else {
            count++;
          }
        }
      } else { // 数据异常 || 不足(可删 初始化数组里加了兼容最少7个单元时间段)
        if (arr.length == 0) {
          result[0] = {
            left: 0,
            width: cellOneWidth,
            show: this.$dayjs().format(_showFormat),
            date: this.$dayjs(),
          };
        } else {
          result[0] = {
            left: 0,
            width: count * cellOneWidth,
            show: arr[0].date.format(_showFormat),
            date: arr[0].date,
          };
        }
      }
      return result;
    },
    // 二级时间轴单位·网格数组
    timesSec() {
      return this.$store.getters.durationTimeArr;
    },
    // 三级是否显示
    timesThirdShow() {
      const _timesThirdShow = this.$store.getters.timelineShowRows ? (this.$store.getters.timelineShowRows >= 3) : false;
      return _timesThirdShow;
    },
    // 四级是否显示
    timesFourthShow() {
      const _timesFourthShow = this.$store.getters.timelineShowRows ? (this.$store.getters.timelineShowRows > 3) : false;
      return _timesFourthShow;
    },
  },
  methods: {
    /*
      横道右键菜单
      如果内容高度小于点击与底部的差值则向上
    */
    ContextmenuHandle(e) {
      return false;
    },
  },
  components: {},
};
</script>

<style scoped lang='less'>
.gantt-header {
  font-size: @fs12;
  color: @cBlack;
  line-height: @timesLineHeight;
  &.gantt-outbox-border{
    position: relative;
    &::after{
      content: "";
      border-right: 1px solid @cBorder;
      border-right: 1px solid var(--border-color, @cBorder);
      position: absolute;
      right: 0;
      top: 0;
      width: 1px;
      height: 100%;
    }
    .gantt-row{
      &:first-of-type{
        border-top: 1px solid @cBorder;
        border-top: 1px solid var(--border-color, @cBorder);
      }
    }
  }

  .gantt-row {
    display: block;
    height: @timesLineHeight;
    position: relative;
    // 竖直模式
    &.gantt-row-vertical{}
    &.gantt-row-first{
      &.gantt-row-vertical{}
    }
    &.gantt-row-sec, &.gantt-row-third, &.gantt-row-fourth{
      &.gantt-row-vertical{
        .cell-item {
          line-height: @timesLineHeight / 2;
        }
      }
    }
    border-bottom: 1px solid @cBorder;
    border-bottom: 1px solid var(--border-color, @cBorder);
    &.noboder {
      border-bottom: none;
    }
    &.gantt-row-first,&.gantt-row-sec,&.gantt-row-third, &.gantt-row-fourth{
      .cell-item{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .cell-item {
      position: relative;
      display: inline-block;
      box-sizing: border-box;
      width: @cellWidth;
      overflow: hidden;
      text-align: center;
      height: @timesLineHeight;
      line-height: @timesLineHeight;
      border-left: 1px solid @cBorder;
      border-left: 1px solid var(--border-color, @cBorder);

      &:first-of-type{
        border-left: none;
      }

      .week-box{
        position: absolute;
        bottom: 1px;
        left: 0;
        width: 100%;
        height: 20%;
        overflow: hidden;
        display: flex;
        .week-col{
          flex: 1;
          height: 100%;
          border-right: 1px solid @cNomal;
          &:last-of-type{
            border-right: none;
          }
        }
      }
      .cell-item-weekday{
        color: blue;
      }
      &.cell-item-weekend{
        color: red;
      }
      &.cell-item-bg{
        background-color: var(--gantt-timeline-bg-color, @cTimelineBgDates);
      }
    }
    .borderL {
      border-left: 1px solid @cBorder;
      border-left: 1px solid var(--border-color, @cBorder);
    }
    .borderR {
      border-right: 1px solid @cBorder;
      border-right: 1px solid var(--border-color, @cBorder);
    }
  }
}
</style>
